import React, { FC, useEffect, useRef, useState } from 'react'
import { Button, Row, Modal, Col, Form,Checkbox, message } from 'antd'
import { YHDrawer } from '@/components/YhDrawer'
import { userControlModel } from "../userControlModel";
import { YhFormBox } from "@/components/YhFormBox"
import { userControlService } from "../userControlService";
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, IYhFormRef } from '@/components/YhFormBoxVertical/Types'
import { getFormValidatorErrText } from '@/utils/utils';
import { DictCodeEnmu } from '@/types/AppDictEnums';
import { useDictModel, ITreeSelectData } from '../../dict/dictModel'
import moment from 'moment';

export const UserDetail = () => {
    const { getSelectedDictOne } = useDictModel()
    const {
        userDetailVisible: visible,addFormVal,selectedRowKeys,updateAddFormVal,setUserDetailVisible,insertData,
    } = userControlModel();
    const formRef = useRef<IYhFormRef>();
    const [dataSource, setDataSource] = useState<any>({});
    useEffect(() => {
     
    }, [])
    //监听批量录入字段
    const onChange =  (changedValues: { [key: string]: any }) => {
        setDataSource({...dataSource,...changedValues})
    }
    const onCancel = () => {
        setUserDetailVisible(false)
    }
    const onOk =  async () => {
        formRef.current?.validateFields().then(val => {
            let data = {}
            insertData(data).then(res => {
                    res && onCancel()
                })
        }).catch(err => {
            message.warning(getFormValidatorErrText(err));
        })
    }
    const onReset = () => {}
    const FormItem:IYhFormItemsBox = {
        title: '',
        style: { padding: '0 20px', marginBottom: '10px' },
        disabled:true,
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "用户编码",
                fieldName: "code",
                disable:true,
                span: 24,
                placeholder:'自动生成',
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "用户名称",
                fieldName: "name",
                span: 24,
                placeholder:'请输入'
            },            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '用户类型',
                fieldName: 'userTypeName',
                span: 24,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "所属部门",
                fieldName: "orgName",
                span: 24,
                placeholder:'请输入'
            },   {
                type: FormItemTypeEnum.Input,
                fieldLabel: "联系电话",
                fieldName: "phoneNumber",
                span: 24,
                placeholder:'请输入'
            },  {
                type: FormItemTypeEnum.Input,
                fieldLabel: "创建人",
                fieldName: "createUser",
                span: 24,
                placeholder:'请输入'
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "创建时间",
                fieldName: "createTime",
                span: 24,
                placeholder:'请输入',
            }, {
                type: FormItemTypeEnum.Switch,
                fieldLabel: "用户状态",
                fieldName: "status",
                span: 18,
            }, 
        ],
    }
    const formConfig:any = {
        labelCol: { span: 24 },
        formRef,
        labelAlign: 'right',
        formValues: {...selectedRowKeys,status:selectedRowKeys.status?0:1,createTime:moment(selectedRowKeys.createTime).format("YYYY-MM-DD HH:mm:ss")},
        onChange,
        boxs: [FormItem],
    }
    return (
        <YHDrawer
            {...{
                title: "用户信息查看",
                visible,
                onCancel,
            }}
        >
            <Row>
            <YhFormBox {...formConfig}/>
            </Row>
        </YHDrawer>
    )
}
